import { render, staticRenderFns } from "./PublishStatusToggle.vue?vue&type=template&id=3f25886e&lang=pug&"
import script from "./PublishStatusToggle.vue?vue&type=script&lang=js&"
export * from "./PublishStatusToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports